export const recoCarouselContainerTagName: "reco-carousel-container" =
  "reco-carousel-container" as const;
